/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Meta_DescriptionInputs */

const ja_playdata_home_meta_description = /** @type {(inputs: Playdata_Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）は国内eスポーツ大会・イベントの視聴データを様々な角度で分析したレポートを提供しています。同時視聴者数の動向や、同時間帯に配信された他のゲームのeスポーツ大会の視聴データ比較分析など、深い洞察を可能にします。`)
};

const en_playdata_home_meta_description = /** @type {(inputs: Playdata_Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our reports unlock deep insights for domestic Japanese esports and live game streams.`)
};

/**
* | output |
* | --- |
* | "Our reports unlock deep insights for domestic Japanese esports and live game streams." |
*
* @param {Playdata_Home_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_meta_description = /** @type {((inputs?: Playdata_Home_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_meta_description(inputs)
	return en_playdata_home_meta_description(inputs)
});